import { comics, type Comic } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import SectionTitle from "@/components/feature/SectionTitle";

export function LatestGrid() {
  const list = [...comics]
    .filter((c) => c.latest)
    .sort((a, b) => b.views - a.views)
    .slice(0, 10);
  return (
    <ComicGridSection
      kicker="Latest Updates"
      title="最新更新"
      desc="每日同步全网最新话更新，追更不迷路。"
      moreTo="/category/all?sort=latest"
      list={list}
    />
  );
}

export function TopRatedGrid() {
  const list = [...comics]
    .filter((c) => c.top)
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 10);
  return (
    <ComicGridSection
      kicker="Top Rated"
      title="高分佳作"
      desc="由读者真实评分选出的口碑韩漫，每一部都值得细细品味。"
      moreTo="/category/all?sort=rating"
      list={list}
      bg="bg-background-100"
    />
  );
}

function ComicGridSection({
  kicker,
  title,
  desc,
  moreTo,
  list,
  bg = "",
}: {
  kicker: string;
  title: string;
  desc: string;
  moreTo: string;
  list: Comic[];
  bg?: string;
}) {
  return (
    <section className={`section-pad ${bg}`}>
      <div className="container-x">
        <SectionTitle kicker={kicker} title={title} desc={desc} moreTo={moreTo} />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}